@theme inline {
  --color-background-default: var(--background-default);
  --color-background-subtle: var(--background-subtle);
  --color-surface-default: var(--surface-default);
  --color-surface-raised: var(--surface-raised);
  --color-surface-sunken: var(--surface-sunken);
  --color-text-default: var(--text-default);
  --color-text-muted: var(--text-muted);
  --color-text-subtle: var(--text-subtle);
  --color-text-inverse: var(--text-inverse);
  --color-text-link: var(--text-link);
  --color-border-default: var(--border-default);
  --color-border-subtle: var(--border-subtle);
  --color-border-strong: var(--border-strong);
  --color-action-default: var(--action-default);
  --color-action-hover: var(--action-hover);
  --color-action-subtle: var(--action-subtle);
  --color-success-surface: var(--success-surface);
  --color-success-text: var(--success-text);
  --color-success-border: var(--success-border);
  --color-success-solid: var(--success-solid);
  --color-warning-surface: var(--warning-surface);
  --color-warning-text: var(--warning-text);
  --color-warning-border: var(--warning-border);
  --color-warning-solid: var(--warning-solid);
  --color-danger-surface: var(--danger-surface);
  --color-danger-text: var(--danger-text);
  --color-danger-border: var(--danger-border);
  --color-danger-solid: var(--danger-solid);
  --color-info-surface: var(--info-surface);
  --color-info-text: var(--info-text);
  --color-info-border: var(--info-border);
  --color-info-solid: var(--info-solid);
}

:root {
  --background-default: rgb(250, 250, 250);
  --background-subtle: rgb(245, 245, 245);
  --surface-default: rgb(255, 255, 255);
  --surface-raised: rgb(255, 255, 255);
  --surface-sunken: rgb(245, 245, 245);
  --text-default: rgb(14, 17, 19);
  --text-muted: rgb(73, 80, 84);
  --text-subtle: rgb(136, 143, 146);
  --text-inverse: rgb(255, 255, 255);
  --text-link: rgb(0, 38, 100);
  --border-default: rgb(220, 223, 224);
  --border-subtle: rgb(235, 235, 235);
  --border-strong: rgb(136, 143, 146);
  --action-default: rgb(0, 38, 100);
  --action-hover: rgb(0, 16, 55);
  --action-subtle: rgb(240, 251, 255);
  --success-surface: rgb(239, 249, 237);
  --success-text: rgb(0, 90, 2);
  --success-border: rgb(143, 199, 138);
  --success-solid: rgb(0, 138, 7);
  --warning-surface: rgb(255, 243, 237);
  --warning-text: rgb(136, 47, 3);
  --warning-border: rgb(238, 168, 138);
  --warning-solid: rgb(201, 80, 0);
  --danger-surface: rgb(255, 240, 239);
  --danger-text: rgb(124, 6, 31);
  --danger-border: rgb(234, 146, 148);
  --danger-solid: rgb(184, 18, 55);
  --info-surface: rgb(233, 238, 247);
  --info-text: rgb(25, 51, 102);
  --info-border: rgb(128, 152, 194);
  --info-solid: rgb(46, 82, 153);
}
